<template>
  <div class="linear-results">
    <div class="status-row">
      <strong>{{ parseTranslation(OPTION) }}</strong>

      <div class="numbers">
        <strong>{{ parseTranslation(COUNT) }}</strong>
        <strong>{{ parseTranslation(PERCENTAGE) }}</strong>
      </div>
    </div>

    <hr class="divider" />

    <div
      class="status-row"
      v-for="result in question_result.results"
      :key="`${question_result.code}-${result.code}`"
    >
      <span>{{ result.label }}</span>

      <div class="numbers">
        <span>{{ result.count }}</span>
        <span>{{ result.percentage }}</span>
      </div>
    </div>

    <div class="status-row total-row">
      <strong>Total</strong>

      <div class="numbers">
        <strong>{{ question_result.count }}</strong>
        <strong>100%</strong>
      </div>
    </div>
  </div>
</template>

<script>
import * as translationLinear from './Linear.translations'

const { default: translations, ...translationKeys } = translationLinear

export default {
  props: {
    question_result: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      translations,
      ...translationKeys,
    }
  },
}
</script>

<style lang="scss" scoped>
.divider {
  /* inner padding */
  width: calc(100% - 32px);
  margin: 0 auto;
  height: 2px;
  border: none;
  background: $gray;
}

.status-row {
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  color: $white;

  .light & {
    color: $main;
  }

  > span {
    width: 80%;
    white-space: normal;
    word-break: break-all;
    line-height: 1.125rem;
  }

  &.total-row {
    color: $gray-2;
  }
}

.numbers {
  @include flexAlignCenter;
  justify-content: flex-end;
  width: Max(20%, 140px);

  span,
  strong {
    text-align: end;
    width: 48%;

    & + span,
    & + strong {
      margin-left: 12px;
    }
  }
}
</style>
